import React from "react";

import styled from "@emotion/styled";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";

import {
  FieldContainer,
  RadioGroup,
  RadioItem,
  SubFieldContainer,
  CheckboxGroup,
  CheckboxItem,
  CustomSelect,
  Option,
  Label,
  Note,
  Highlight,
} from "../../components/CustomFields";

import {
  flavoured,
  noFlavoured,
  quantityOptions,
  soyMilkFlavoured,
  soyMilkNoFlavoured,
} from "./CowMilk";
import { vegetableOptions } from "./Vagetable";
import { exerciseTimeOptions } from "./Excercise";
import {
  normalSweet,
  quantityOptions as sweetDrinkQuantityOptions,
  sweetLess,
} from "./SweetDrink";

const QuantitySummary = ({ quantityList, form }) => (
  <QuantityContainer>
    <Row>
      <Header>ขนาด</Header>
      <Header>จำนวน</Header>
    </Row>
    {quantityList.map(
      ({ name, label, desc }) =>
        form[name] && (
          <Row>
            <TitleContainer>
              <Title>{label}</Title> <Desc>{desc}</Desc>
            </TitleContainer>
            <FieldContainer name={name} style={{ width: 100 }}>
              <SmallCustomSelect placeholder="ระบุ" allowClear disabled>
                {quantityOptions.map((opt) => (
                  <Option value={opt.value}>{opt.label}</Option>
                ))}
              </SmallCustomSelect>
            </FieldContainer>
          </Row>
        )
    )}
  </QuantityContainer>
);

const CowMilk = ({ form }) => (
  <>
    <InformName>ดื่มดี นมวัว</InformName>
    {form.haveDrunkCowMlik ? (
      <>
        {form.noFlavoured && form.noFlavoured.includes("noFlavoured") && (
          <Selected>
            นมวัว<Highlight>รสจืด</Highlight>
          </Selected>
        )}
        {form.noFlavoured && form.noFlavoured.includes("noFlavoured") && (
          <QuantitySummary quantityList={noFlavoured} form={form} />
        )}
        {form.flavoured && form.flavoured.includes("flavoured") && (
          <Selected>
            นมวัว<Highlight>ปรุงแต่งรส</Highlight>
            <br />
            <Label>เช่น นมรสช็อคโกแลต, นมรสหวาน, นมรสกล้วย เป็นต้น</Label>
          </Selected>
        )}
        {form.flavoured && form.flavoured.includes("flavoured") && (
          <QuantitySummary quantityList={flavoured} form={form} />
        )}
        {form.soyMilkNoFlavoured &&
          form.soyMilkNoFlavoured.includes("soyMilkNoFlavoured") && (
            <Selected>
              นมวัวถั่วเหลือง<Highlight>รสจืด</Highlight>
            </Selected>
          )}
        {form.soyMilkNoFlavoured &&
          form.soyMilkNoFlavoured.includes("soyMilkNoFlavoured") && (
            <QuantitySummary quantityList={soyMilkNoFlavoured} form={form} />
          )}
        {form.soyMilkFlavoured &&
          form.soyMilkFlavoured.includes("soyMilkFlavoured") && (
            <Selected>
              นมวัวถั่วเหลือง<Highlight>รสหวาน</Highlight>
            </Selected>
          )}
        {form.soyMilkFlavoured &&
          form.soyMilkFlavoured.includes("soyMilkFlavoured") && (
            <QuantitySummary quantityList={soyMilkFlavoured} form={form} />
          )}
      </>
    ) : (
      <UnSelected>ไม่ได้ดื่ม</UnSelected>
    )}
  </>
);

const Vegetable = ({ form }) => (
  <>
    <InformName>สุขชัวร์ เพิ่มผัก</InformName>
    {form.haveEatenVegetable && <Selected>กิน</Selected>}
    {form.haveEatenVegetable ? (
      <FieldContainer name="vegetableCount" label="">
        <LargeCustomSelect placeholder="โปรดระบุ" allowClear disabled>
          {vegetableOptions.map((opt) => (
            <Option value={opt.value}>{opt.label}</Option>
          ))}
        </LargeCustomSelect>
      </FieldContainer>
    ) : (
      <UnSelected>ไม่ได้กิน หรือ กินน้อยกว่า 1 ช้อนโต๊ะ</UnSelected>
    )}
  </>
);

const Exercise = ({ form }) => (
  <>
    <InformName>รักออกกำลัง</InformName>
    {form.haveExercised && <Selected>ออกกำลังกาย</Selected>}
    {form.haveExercised ? (
      <FieldContainer name="exerciseTime" label="">
        <LargeCustomSelect placeholder="โปรดระบุ" allowClear disabled>
          {exerciseTimeOptions.map((opt) => (
            <Option value={opt.value}>{opt.label}</Option>
          ))}
        </LargeCustomSelect>
      </FieldContainer>
    ) : (
      <UnSelected>ไม่ได้ออกกำลัง</UnSelected>
    )}
  </>
);

const SweetDrink = ({ form }) => (
  <>
    <InformName>หยุดยั้งน้ำหวาน</InformName>
    {form.haveDrunkSweetDrink ? (
      <>
        {form.normalSweet && form.normalSweet.includes("normalSweet") && (
          <Selected>น้ำหวาน</Selected>
        )}
        {form.normalSweet && form.normalSweet.includes("normalSweet") && (
          <QuantitySummary quantityList={normalSweet} form={form} />
        )}

        {form.sweetLess && form.sweetLess.includes("sweetLess") && (
          <Selected>
            น้ำหวาน<Highlight>หวานน้อย</Highlight>
            <br />
            <Label>
              น้ำหวานหวานน้อย เช่น เครื่องดื่มที่เติมน้ำตาลเทียม,สั่งน้ำชงแบบ
              หวานน้อย
            </Label>
          </Selected>
        )}
        {form.sweetLess && form.sweetLess.includes("sweetLess") && (
          <QuantitySummary quantityList={sweetLess} form={form} />
        )}
      </>
    ) : (
      <UnSelected>
        ไม่ดื่มน้ำหวานเลย
        <Label>
          <br />
          (น้ำหวาน หมายถึง น้ำหวานที่เติมน้ำตาล น้ำหวานที่เติมน้ำตาลเทียม
          และน้ำผลไม้ที่มีรสหวาน)
        </Label>
      </UnSelected>
    )}
  </>
);

const Summary = ({ form = {} }) => {
  return (
    <Container>
      <Caution>
        {"ข้อมูลไม่สามารถกลับมาแก้ไขได้\nตรวจคำตอบของท่านก่อนเลือกบันทึก"}
      </Caution>
      <CowMilk form={form} />
      <Vegetable form={form} />
      <Exercise form={form} />
      <SweetDrink form={form} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 911px;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  ${responsive.tablet(css`
    max-width: unset;
    width: calc(100% - 64px);
  `)}

  ${responsive.mobile(css`
    width: calc(100% - 32px);
  `)}
`;

const Caution = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;

  text-align: center;

  color: #92400e;

  margin-bottom: 24px;

  white-space: pre-line;

  ${responsive.mobile(css`
    margin-bottom: 16px;
  `)}
`;

const InformName = styled.span`
  width: 100%;

  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;

  letter-spacing: -0.02em;

  color: #058459;

  margin-bottom: 8px;

  ${responsive.mobile(css`
    font-size: 23px;
    line-height: 28px;

    margin-bottom: 8px;
  `)}
`;

const Selected = styled(Note)`
  width: 100%;
`;

const UnSelected = styled(Note)`
  width: 100%;

  margin-bottom: 24px;
`;

const QuantityContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 16px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;

  width: 400px;
  margin-bottom: 4px;

  ${responsive.mobile(css`
    width: 100% !important; ;
  `)}
`;

const Header = styled.span`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;

  color: #058459;

  width: 100px;
`;

const TitleContainer = styled.span`
  width: 300px;
  line-height: 52px;
`;

const Title = styled.span`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;

  color: #4b5768;
`;

const Desc = styled.span`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;

  color: #4b5768;
`;

const LargeCustomSelect = styled(CustomSelect)`
  width: 400px !important;

  ${responsive.mobile(css`
    width: 100% !important;
  `)}
`;

const SmallCustomSelect = styled(CustomSelect)`
  width: 100px !important;
  margin-bottom: 0;

  ${responsive.mobile(css`
    margin-bottom: 0;
  `)}
`;

export default Summary;
